import * as React from 'react';
declare const I18n;

import CardItem from '../../../resource/components/card_item'

type Resource = {
  featured?: boolean
  id: number
  title: string
  resource_type: string
  resource_id?: number
  url?: string
  cover_image_data: string | null
  cover_image_url?: string | null
  length_estimate: string
  category_list: string | null
  resource_category_id: number
  body?: string
}

type Categories = {
  id: number
  name: string
  cover_image_url?: string
}

type Props = {
  resources: Array<Resource>
  categories: Array<Categories>
  isFacilitator?: boolean
  isLearner?: boolean
  isAdmin?: boolean
  heading: string
  viewAllText: string
  viewAllUrl: string
  emptyStateText: string
}

const IndexResourceCategory: React.FunctionComponent<Props> = ({
  resources, categories, isLearner, isAdmin
}: Props): JSX.Element => {
  const items = resources || []
  const cats = categories || []

  const [selectedCat, setSelectedCat] = React.useState(null);

  const filterItems = () => {
    if (selectedCat === null) {
      return items;
    }
    return items.filter(item => item.resource_category_id === selectedCat);
  };

  return (
    <div className="resource_categories_index">

      {isAdmin && (
        <div className="d-flex align-items-center justify-content-between mb-5">
          <h1 className="mb-0">
            {I18n.t('models.resource_category.messaging.explore_resources')}
          </h1>

          <div className="d-flex gap-4">
            <a className="btn btn-primary" href="/admin/explore_categories/all">{I18n.t('models.resource_category.attributes.view_categories')}</a>
          </div>
        </div>
      )}

      {!isAdmin && (<h1>{I18n.t('models.resource_category.messaging.explore_resources')}</h1>)}
      
      <h2 className="yellow">{I18n.t('models.resource_category.messaging.filter_by_category')}</h2>
      <div
        className="cat-buttons"
      >
        <button
          className={`btn btn-square ${selectedCat === null ? 'active' : ''}`}
          key="all"
          onClick={() => { setSelectedCat(null) }}>
          {I18n.t('views.common.all')}
        </button>
        {
          cats.length > 0 ? (
            <>
              {
                cats.map((categories, index) => (
                  <button
                    className={`btn btn-square ${selectedCat === categories.id ? 'active' : ''}`}
                    key={categories.id}
                    onClick={() => { setSelectedCat(categories.id) }}>
                    {categories.name}
                  </button>
                ))
              }
            </>
          ) : null
        }
      </div>

      {
        filterItems().length > 0 ? (
          <div className="courses_index__list">
            {
              filterItems().map((resource, index) => (
                <CardItem
                  resource={resource}
                  isAdmin={false}
                  isLearner={isLearner}
                  resourceCategoryId={resource.resource_category_id}
                  index={index}
                  handleDelete={() => { }}
                  showCategory={true}
                  cardBackground="primary"
                />
              ))
            }
          </div>
        ) : (
          <div className="courses_index__empty-state app-text" style={{ width: '100%' }}>
            {I18n.t('models.resource.messaging.no_resource_category')}
          </div>
        )
      }
    </div>
  );
}

export default IndexResourceCategory;
